import { useEffect } from "react";
import { Link } from "react-router-dom";
import { HouseLine, Trophy, BookOpenText, List, Calculator, Lock } from "@phosphor-icons/react";

const TABS = [
  { id: "daily", to: "/app", label: "Today", icon: HouseLine },
  { id: "calculator", to: "/app/calculator", label: "Calculator", icon: Calculator },
  { id: "scoreboard", to: "/app/scoreboard", label: "Scoreboard", icon: Trophy },
  { id: "journal", to: "/app/journal", label: "Journal", icon: BookOpenText },
  { id: "more", to: "/app/more", label: "More", icon: List },
];

export const CaddyBottomNav = ({ active, sprint = false }) => {
  useEffect(() => {
    document.body.classList.add("has-caddy-nav");
    return () => document.body.classList.remove("has-caddy-nav");
  }, []);
  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40"
      style={{
        background: "rgba(255,255,255,0.97)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderTop: "0.5px solid var(--pr-card-border)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="caddy-bottom-nav"
    >
      <div className="max-w-md mx-auto grid grid-cols-5">
        {TABS.map(({ id, to, label, icon: Icon, seasonOnly }) => {
          const isActive = id === active;
          const locked = sprint && seasonOnly;
          return (
            <Link
              key={id}
              to={to}
              className="flex flex-col items-center gap-0.5 pt-2 pb-1 relative"
              style={locked ? { opacity: 0.55 } : undefined}
              data-testid={`bottom-nav-${id}`}
              aria-label={locked ? `${label}, Season Pass feature` : label}
            >
              {locked && <Lock size={10} weight="fill" className="absolute top-1.5 right-[22%]" style={{ color: "#8B7E6A" }} data-testid={`bottom-nav-lock-${id}`} />}
              <Icon size={22} weight={isActive ? "fill" : "regular"} style={{ color: isActive ? "#2A1E5C" : "#8B7E6A" }} />
              <span className="text-[11px] font-bold leading-none" style={{ color: isActive ? "#2A1E5C" : "#8B7E6A" }}>{label}</span>
              <span className="h-1 w-1 rounded-full" style={{ background: isActive ? "#F5CB5C" : "transparent" }} />
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
